import {Injectable} from '@angular/core';
import {ConfigurationProperties} from '../models/configuration.properties';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AppConfig {
  private _config: ConfigurationProperties;
  constructor(private http: HttpClient) {
  }

  get config(): ConfigurationProperties {
    return this._config;
  }

  set config(value: ConfigurationProperties) {
    this._config = value;
  }

  load() {
    return new Promise((resolve) => {
      this.http.get('/properties')
        .subscribe((response: ConfigurationProperties) => {
          this._config = response;
          resolve();
        });
    });
  }
}
